import { create } from 'zustand';
import { useShallow } from 'zustand/shallow';

interface ILayoutStore {
  /**
   * State
   */
  isOpenSidebar: boolean;
  isOpenDrawer: boolean;
  isHasDrawer: boolean;

  /**
   * Actions
   */

  actions: {
    setIsOpenSidebar: (isOpenSidebar: boolean) => void;
    setIsOpenDrawer: (isOpenDrawer: boolean) => void;
    setIsHasDrawer: (isHasDrawer: boolean) => void;
  };
}

export const layoutStore = create<ILayoutStore>((set) => ({
  /**
   * State
   */

  isOpenSidebar: false,

  isOpenDrawer: true,
  isHasDrawer: false,

  /**
   * Actions
   */
  actions: {
    setIsOpenSidebar: (isOpenSidebar: boolean) => {
      set((prev) => {
        const sameIsOpenSidebar = prev.isOpenSidebar === isOpenSidebar;
        // No changes, return previous state to prevent unnecessary re-renders
        if (sameIsOpenSidebar) return prev;

        return { isOpenSidebar };
      });
    },
    setIsOpenDrawer: (isOpenDrawer: boolean) => {
      set((prev) => {
        const sameIsOpenDrawer = prev.isOpenDrawer === isOpenDrawer;
        if (sameIsOpenDrawer) return prev;
        return { isOpenDrawer };
      });
    },
    setIsHasDrawer: (isHasDrawer: boolean) => {
      set((prev) => {
        const sameIsHasDrawer = prev.isHasDrawer === isHasDrawer;
        if (sameIsHasDrawer) return prev;
        return { isHasDrawer };
      });
    },
  },
}));

/**
 * Selectors
 */
export const useIsOpenSidebarState = () => layoutStore(useShallow((state) => state.isOpenSidebar));

export const useIsOpenDrawerState = () => layoutStore(useShallow((state) => state.isOpenDrawer));

export const useIsHasDrawerState = () => layoutStore(useShallow((state) => state.isHasDrawer));

/**
 * Actions
 */
export const useLayoutStoreActions = () => layoutStore(useShallow((state) => state.actions));
